// extracted by mini-css-extract-plugin
export default {"glyphicon":"w2xFN__glyphicon glyphicon glyphicon-cog"};